import React, { Component } from "react";
import { Link, Route, Switch, withRouter } from "react-router-dom";
import Header from "./Header";
import VUStepper from "../tags/Stepper";

import Start from "../pages/Start";
import ConfirmDetails from "../pages/ConfirmDetails";
import AdditionalDetails from "../pages/AdditionalDetails";
import UsiDetails from "../pages/UsiDetails";
import Units from "../pages/Units";
import FinancialSupport from "../pages/FinancialSupport";

import {
  getStepByIndex,
  getStepIndexByUrl,
  getStepProgress,
} from "../../helpers/steps";

import Help from "./Help";
import ThankYou from "../pages/ThankYou";
import { getConfiguration } from "../../helpers/configuration";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
  }

  componentDidMount() {
    if (this.getCurrentStepIndex() !== this.getTargetStepIndex()) {
      this.props.history.push(getStepByIndex(this.getTargetStepIndex()).url);
    }
  }

  getTargetStepIndex = () => {
    const stepProgress = getStepProgress();

    let targetStepIndex = 0;

    // Try and redirect the user to either the requested URL path (if that path
    // is not disabled) or the last active form.

    const requestedStepIndex = this.getCurrentStepIndex();

    if (
      requestedStepIndex !== -1 &&
      getStepByIndex(requestedStepIndex).disabled === false
    ) {
      targetStepIndex = requestedStepIndex;
    } else {
      const activeSteps = stepProgress.filter(
        (step) => step.disabled === false,
      );
      if (activeSteps.length > 0) {
        const lastActiveStep = activeSteps[activeSteps.length - 1];
        targetStepIndex = stepProgress.findIndex(
          (step) => step.url === lastActiveStep.url,
        );
      }
    }

    return targetStepIndex;
  };

  getCurrentStepIndex = () => {
    return getStepIndexByUrl(this.props.location.pathname);
  };

  isHomePage = () => this.getCurrentStepIndex() === 0;

  render() {
    return (
      <div id="app">
        <Header
          onHamburgerClick={() =>
            this.setState({
              drawerOpen: true,
            })
          }
        />
        <Help
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false,
            })
          }
        />
        <main id="content">
          <div className="mainBannerContainer">
            <div className={["mainBannerContent", "homePage"].join(" ")}>
              {this.getCurrentStepIndex() === -1 &&
              this.getCurrentStepIndex() < getStepProgress().length ? null : (
                <div className="row">
                  <div className="col-xs-12">
                    <h1>{getStepByIndex(this.getCurrentStepIndex()).header}</h1>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="bodyContainer">
            <div className="enrol-container">
              <div className="row">
                <div className="mainContainer col-xs-12">
                  <Switch>
                    <Route
                      path={getConfiguration("baseUrl") + "/"}
                      exact
                      component={Start}
                    />
                    <Route
                      path={getConfiguration("baseUrl") + "/confirm_details"}
                      component={ConfirmDetails}
                    />
                    <Route
                      path={getConfiguration("baseUrl") + "/additional_details"}
                      component={AdditionalDetails}
                    />
                    <Route
                      path={getConfiguration("baseUrl") + "/usi_details"}
                      component={UsiDetails}
                    />
                    <Route
                      path={getConfiguration("baseUrl") + "/financial_support"}
                      component={FinancialSupport}
                    />
                    <Route
                      path={getConfiguration("baseUrl") + "/units"}
                      component={Units}
                    />
                    <Route
                      path={getConfiguration("baseUrl") + "/thankyou"}
                      component={ThankYou}
                    />
                  </Switch>
                </div>
              </div>
            </div>
            <div className="sidebar-content">
              <aside className="sideBar">
                <VUStepper />
              </aside>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default withRouter(Layout);
